import { jsx as _jsx } from "react/jsx-runtime";
import { SDKData } from "./SDKData";
export const SDKCard = ({ data }) => {
    return _jsx(SDKData, { data: data });
};
